module.exports = __webpack_public_path__ + "static/img/xlsx.d28c13b4.png";